import { SET_EMPLOYEE } from '../mutation-types'
import CompanyApi from '../../api/CompanyApi'

const getEmployee = ({ companyId, employeeId }) => {
  return CompanyApi.getEmployee(employeeId)
}

const editEmployee = ({ companyId, employee }) => {
  return CompanyApi.editEmployee(employee)
}

const state = {
  currentEmployee: null
}

const getters = {
  currentEmployee: (state) => state.currentEmployee
}

const actions = {

  async getEmployee ({ state, commit }, { companyId, employeeId, force }) {
    if (!state.currentEmployee || force || `${state.currentEmployee.id}` !== `${employeeId}`) {
      commit(SET_EMPLOYEE, null)
      const employee = await getEmployee({ companyId, employeeId })
      commit(SET_EMPLOYEE, employee)
      return employee
    } else {
      return { companyId, employeeId }
    }
  },

  async saveEmployee ({ dispatch, commit }, { companyId, employee }) {
    const result = await editEmployee({ companyId, employee })
    dispatch('getEmployee', { companyId, employeeId: employee.id, force: true })
    return result
  }
}

const mutations = {
  [SET_EMPLOYEE] (state, employee) {
    state.currentEmployee = employee
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
